import { Drawer } from '@templates/index';
import { useUiStore } from '@store/index';
import { SettingsPanel } from './SettingsPanel';

/**
 * Slide-in panel from the right. Triggered by the gear button in the
 * stage, the `S` shortcut (toggle), or `Esc` (close).
 */
export function SettingsDrawer() {
  const open = useUiStore((s) => s.settingsOpen);
  const setOpen = useUiStore((s) => s.setSettingsOpen);
  const toggle = useUiStore((s) => s.toggleSettings);

  return (
    <Drawer
      open={open}
      onClose={() => setOpen(false)}
      onToggle={toggle}
      title="Settings"
      shortcut="s"
      hint={
        <>
          Shortcut: <kbd>S</kbd> toggle · <kbd>Esc</kbd> close
        </>
      }
    >
      <SettingsPanel />
    </Drawer>
  );
}
